/* @flow weak */
import { ActionTypes } from '../constants/TransactionConstants';
import Transactions from 'collections/Transactions';

export const initialState = {
  transactions: new Transactions(),
};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.LOAD_TRANSACTIONS:
      const transactions = state.transactions.clone();
      transactions.add(action.transactions.models);
      return { ...state, transactions };

    case ActionTypes.CREATE_TRANSACTION:
    case ActionTypes.CLAIM_TRANSACTION:
      const updatedTransactions = state.transactions.clone();
      updatedTransactions.add(action.transaction);
      return { ...state, transactions: updatedTransactions };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/payments/reducers/Transactions.js